module.exports = __webpack_public_path__ + "media/images/landing__teaser__scoring--mobile-43b4204b0662a97d373908857f52194b.png";